import { EditorTools } from "@progress/kendo-react-editor";
import { isMobile } from "react-device-detect";

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    ForeColor,
    BackColor,
    Link,
    Unlink,
    ViewHtml,
} = EditorTools;

export const CommonTools: any[] = [
    [Bold, Italic, Underline, Strikethrough],
    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
    [OrderedList, UnorderedList],
    ForeColor,
    BackColor,
    FontSize,
    FontName,
    //V25 - too much space
    //FormatBlock,
    [Undo, Redo],
    [Link, Unlink, ViewHtml],
];

export const MobileTools: any[] = [
    [Bold, Italic, Underline, Strikethrough],
    [OrderedList, UnorderedList],
    [Undo, Redo]
];
